<template>
  <div class="cd-modal">
    <div class="cd-title">
      <div class="l">
        <i class="l-icon" style="color: #1890FF;"></i> 创建好了吗？试试下面这{{has_sub ? 2 : 3}}项
      </div>
      <SeoLink class="r" :to="{ name: 'helpCenter' }">帮助<img  class="r-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220316/a88cb4790c49d6b5b8de174f7ed19d79.svg" alt=""></SeoLink>
    </div>
    <div class="cd-item" v-if="!has_sub" @click="btnClick(0)">
      <div class="l">
        <div class="l-title">开启消息</div>
        <div class="l-desc">关注公众号，及时接收消息提醒</div>
      </div>
      <div class="r">去开启</div>
    </div>
    <div class="cd-item" @click="btnClick(1)">
      <div class="l">
        <div class="l-title">分享给他人作答</div>
        <div class="l-desc">分享好友和群，生成小程序码和链接</div>
      </div>
      <div class="r">去分享</div>
    </div>
    <div class="cd-item" @click="btnClick(2)">
      <div class="l">
        <div class="l-title">管理更多功能</div>
        <div class="l-desc">作答规则、题目管理、防作弊等</div>
      </div>
      <div class="r">去管理</div>
    </div>
  </div>
</template>

<script>
import SeoLink from "@/components/SeoLink.vue";
export default {
  components: { SeoLink },
  props: {
    has_sub: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      
    };
  },
  methods: {
    btnClick(index) {
      this.$emit('createdClick', index )
    },
  },
};
</script>

<style lang="scss" scoped>
.cd-modal {
  border-radius: 4px;
  background: #FFFFFF;
  padding: 15px;
  font-size: 14px;
  margin: 10px 15px 0;
}
.cd-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cd-title .l {
  display: flex;
  align-items: center;
}
.cd-title .l-icon {
  margin-right: 5px;
}
.cd-title .r {
  color: #1890ff;
  display: flex;
  align-items: center;
}
.r-icon {
  width: 18px;
  height: 18px;
  margin-left: 5px;
}
.cd-item {
  padding: 15px 10px;
  background: #F5F7FA;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 10px;
}
.l-desc {
  font-size: 12px;
  color: #999999;
  margin-top: 2px;
}
.cd-item .r {
  background: #FFFFFF;
  width: 56px;
  height: 27px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #398EFB;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/createdcard.vue